import {Enum} from 'enumify';

export default class ContractStatus extends Enum {}

ContractStatus.initEnum({
  ACTIVE: {
    statusName: 'Live',
  },
  REQUESTED: {
    statusName: 'Requested',
  },
  CANCELED: {
    statusName: 'Canceled',
  },
});



// WEBPACK FOOTER //
// ./src/constants/ContractStatus.js